<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <!-- <div v-if="user">
                <MainlayoutLogin></MainlayoutLogin>
         
        </div>
        <div v-else>
            <Mainlayout></Mainlayout>
        </div> -->
    
        <CCol sm="12" class="bg-white">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <CRow>
                            <CCol sm="6">
                                <div style="margin-top: 20%; position: relative;">
                                    <CButton class="custom-bg-0179FF text-white">✦ 7100+ Image detected ✦</CButton>
                                    <h1 class="font-general-sans text-left custom-72px-500 font-color-2C2C2C" data-aos="fade-left">
                                        AI-Powered Tracking Cameras for the Future
                                    </h1>
                                    <p class="custom-18px-400">Explore the frontier of tracking technology, where AI and machine learning bring unmatched accuracy, adaptability, and intelligence to the world of cameras. These next-gen systems are designed to think, learn, and track
                                        with precision like never before.</p>
                                    <div class="d-flex">
                                        <CButton class="custom-bg-0179FF text-white">Request A Demo</CButton>
                                        <img src="../assets/img/iconarrowup.png" width="40px" height="40px" class="ml-2" />
                                        <img src="../assets/img/groupuser.png" height="40px"  class="ml-2" />
                                    </div>
    
    
                                </div>
                            </CCol>
                            <CCol sm="6">
                                <div class="p-3" style="margin-top: 10%; position: relative;">
    <img src="../assets/img/imgUser.png" style="max-width:80%"/>
    
    <!-- Button and Image positioned at the bottom-left -->
    <div style="position: absolute; bottom: 30px; left: 50px;" class="d-flex" @click="GoToCamera()">
        <!-- Round image positioned slightly above the button -->
        <img src="../assets/img/round.png" height="55px" />
        <!-- Button positioned slightly below the round image -->
        <CButton class="custom-button-white">Try Now</CButton>
    </div>
</div>
                            </CCol>
                        </CRow>
    
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-white mt-5">
            <h3 class="custom-48px-600 text-center">
                Exploring the Next Generation of AI-Powered <br /> Tracking Cameras
            </h3>
                <p class="custom-16px-400 font-color-666D80 text-center" style="width:90%;margin:0 auto;">
                    Discover the cutting-edge advancements in AI-powered tracking cameras that are transforming the way we capture and analyze visual data. These next-generation devices utilize sophisticated algorithms to enhance tracking accuracy, enabling seamless monitoring
                    of subjects in various environments. Whether for security, wildlife observation, or sports analytics, these cameras are designed to adapt and learn, providing users with unparalleled insights and efficiency.
                </p>

                <img src="../assets/img/banner1.png" style="max-width:100%;cursor:pointer"  @click="GoToCameraOnly"/>
<br /><br />
                <img src="../assets/img/banner2.png" style="max-width:100%;cursor:pointer"  @click="GoToOutputOnly"/>
                <br /><br /><br /><br />
        </CCol>
    
    
    
    
        <Footerlayout></Footerlayout>
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

            name: "",
            email: "",
            phone: "",
            password: "",
            selectedUser: "",


            isLanguagePopupVisible: false,
            emailinterest: "",

            selectedExpertise: "",
            selectedField: "",
            //selectedPosition: "",
            expertiseOptions: [], // Initialize as an empty array
            fieldOptions: [], // Initialize as an empty array
            positionOptions: [],
            isLanguagePopupVisible1: false,
            isLanguagePopupVisible2: false,

            Names: "",
            activetab: "",
            isLoved: false, // Initial state
            filter: false,
            hideColumn: true,

            isCategoryListVisible: true, // Toggle state
            isTypeListVisible: false,
            isCategorySeniorityVisible: false,
            categoryJob: [],
            categoryJobType: [],
            categoryJobSeniority: [],
            isLoved: false, // Initial state
            progressBarValue: 50, // Initial value (percentage)
            minSalary: 50000, // Example minimum salary
            maxSalary: 100000, // Example maximum salary
            companyCode: false,
            codeCompany: '',
            ErrorCode: false,
            ShowCode: false,
            Message: "",
            result: {},
            selectedPosition: '',
            ErrorPosition: false,
            user: null,
            Names: "",
        };

    },
    created() {
        AOS.init();

    },

    mounted() {
        this.getListField();
        this.getListExpertise();
        this.getListPosition();
        this.GetListCategoryJob();
        this.GetListCategoryJobType();
        this.GetListCategoryJobSeniority();



        //if (window.location.hostname !== "www.interviewrr.ai") {
        // window.location.href = "https://www.interviewrr.ai";
        //}  
    },
    computed: {
        popupClass() {
            return this.activetab === 'Career' ? 'popup-all1' : 'popup-all2';
        },
        progressBarWidth() {
            return `${this.progressBarValue}%`; // Convert value to percentage for width
        },
    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("Index");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("Index");
                console.error("Error fetching user info:", error);
            }
        },

        OpenFilter() {
            // this.filter = true;
            // this.hideColumn = false;

            this.filter = !this.filter;
            this.hideColumn = !this.hideColumn;

        },
        setActiveTab(tabName) {
            this.activetab = tabName;
        },


        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            //  this.$router.push("HowItWork");
            this.isLanguagePopupVisible1 = true;
        },
        OpenHowItWork() {
            this.$router.push("HowItWork");
        },
        GoToLogin() {
            this.$router.push("Login");
        },
        closePopup() {
            this.isLanguagePopupVisible1 = false;
        },
        closePopup1() {
            this.isLanguagePopupVisible1 = false;
        },
        closePopup2() {
            this.isLanguagePopupVisible1 = false;
            this.isLanguagePopupVisible2 = false;
        },
        OpenPopup() {
            this.isLanguagePopupVisible = false;
            this.isLanguagePopupVisible1 = true;

        },
        SubmitData() {



            const formData = new FormData();

            formData.append("email", this.emailinterest);
            formData.append("experties", this.selectedExpertise.Name);
            formData.append("field", this.selectedField.Name);


            this.$API
                .post(this.$RegisterInterest, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {

                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {

                                this.isLanguagePopupVisible1 = false;
                                this.isLanguagePopupVisible2 = true;

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }

                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        OpenFormVideo() {
            if (!this.selectedPosition || !this.selectedPosition.Name) {
                this.Message = 'Please select your current field';
                this.ErrorPosition = true;
            } else {
                if (this.ErrorCode === true) {
                    this.ErrorPosition = false;
                    this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name)
                } else {
                    if (this.codeCompany === '') {
                        this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name)

                    } else {
                        this.$router.push("FormVideo" + "?expertise=" + this.selectedPosition.Name + "&field=" + this.selectedPosition.Name + "&position=" + this.selectedPosition.Name + "&code=" + this.codeCompany)
                    }

                }


            }
        },
        async getListField() {
            try {
                const response = await this.$API.get(this.$GetListField);
                if (response.status === 200) {
                    this.fieldOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getListExpertise() {
            try {
                const response = await this.$API.get(this.$GetListExpertise);
                if (response.status === 200) {
                    this.expertiseOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getListPosition() {
            try {
                const response = await this.$API.get(this.$GetListPosition);
                if (response.status === 200) {
                    this.positionOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        OpenCalendly() {
            window.open("https://calendly.com/rasid-interviewrr");
        },
        toggleLove() {
            this.isLoved = !this.isLoved;
        },
        async GetListCategoryJob() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJob);
                if (response.status === 200) {
                    this.categoryJob = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleCategoryList() {
            this.isCategoryListVisible = !this.isCategoryListVisible;
        },

        async GetListCategoryJobType() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJobType);
                if (response.status === 200) {
                    this.categoryJobType = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleTypeList() {
            this.isTypeListVisible = !this.isTypeListVisible;
        },

        async GetListCategoryJobSeniority() {
            try {
                const response = await this.$API.get(this.$GetListCategoryJobSeniority);
                if (response.status === 200) {
                    this.categoryJobSeniority = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        toggleSeniorityList() {
            this.isCategorySeniorityVisible = !this.isCategorySeniorityVisible;
        },
        async VerifyCodeData() {
            try {
                this.ErrorPosition = false;
                const codeCompany1 = this.codeCompany;
                const response = await this.$API.get(this.$VerifyCode + '?code=' + codeCompany1); // Assuming this.$VerifyCode is your API endpoint URL

                if (response.status === 200) {
                    this.result = response.data;
                    if (this.result === 'The code is not ready for used.') {
                        this.Message = 'The code is not ready for used.';
                        this.ErrorCode = true;

                    } else if (this.result === 'The code is expired.') {
                        this.Message = 'The code is expired.';
                        this.ErrorCode = true;
                    } else if (this.result === 'The code is invalid.') {
                        this.Message = 'The code is invalid.';
                        this.ErrorCode = true;
                    } else {
                        this.Message = response.data
                        this.ShowCode = true;
                        this.ErrorCode = false;

                    }
                } else {
                    // Handle non-200 status code
                    console.error('Failed to fetch data:', response.statusText);
                }
            } catch (error) {
                // Handle the error here
                console.error('Error fetching data:', error);
            }
        },
        GoToCamera()
        {
            this.$router.push("HomepageImage");
        },
        GoToCameraOnly()
        {
            this.$router.push("Camera");
        },
        GoToOutputOnly()
        {
            this.$router.push("Output");
        },






    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.image-container {
    position: relative;
    max-width: 100%;
}

.background-image {
    width: 100%;
    height: auto;
}

.overlay-text {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    left: 20px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    background-color: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    color: white;
    padding: 10px;
    text-align: center;
    font-size: 1.2em;
    /* Adjust as needed */
    width: 70%;
    margin: 0 auto;
}

pre {
    white-space: pre-wrap;
    /* Ensures that newlines and spaces are rendered as expected */
    color: #171717;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 27px */
}

.bottom-right-button {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    right: 80px;
    /* Adjust as needed */
    padding: 10px 20px;
    background-color: #007bff;
    /* Button color */
    color: white;
    border: none;
    border-radius: 20px;
    cursor: pointer;
}

.bottom-right-button-text {
    position: absolute;
    bottom: 90px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    padding: 10px 20px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: #000;
    font-weight: 600;
}

.bottom-right-button:hover {
    background-color: #0056b3;
    /* Hover color */
}

/* .popup-all1 {
    width: 500px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 2%;
    height:70vh;
} */

.popup-all2 {
    width: 900px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 4%;
    z-index: 1;
    height: 90vh;
}

.salary-range {
    padding: 20px;
}

.progress {
    height: 20px;
    background-color: #e9ecef;
    border-radius: 4px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background-color: #007bff;
}

.custom-range {
    width: 100%;
}

.input-container {
    position: relative;
    display: inline-block;
    width: 100%;
}

input[type="text"].custom {
    padding-right: 60px;
    /* Adjust according to button width */
    height: 80px;
}

.verify-button {
    position: absolute;
    right: 2px;
    top: 3px;
    bottom: 3px;
    height: 28px;
    border-radius: 50px;
    background: #928AFD;
    color: #fff;
    /* Optional: Adjust the button height to match the input field */
}

.disabled {
    cursor: not-allowed;
    opacity: 0.5;
}
</style>